import { render, staticRenderFns } from "./CreateHolidayDateModal.vue?vue&type=template&id=451aa5de&"
import script from "./CreateHolidayDateModal.vue?vue&type=script&lang=js&"
export * from "./CreateHolidayDateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports